<template>
   <v-container fluid>
   <h2 class="text-h4 mb-3">{{$t('contacts.title')}}</h2>
   <template v-if="item">
    <v-card id="pfid1619047636">
        <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" xl="3">
        <v-card-title>{{ $t('contacts.email.title') }}</v-card-title>
        <v-list>
             <v-list-item
                    id="pfid1654354032" 
                    >
                        <v-list-item-icon>
                            <v-icon>$emailRecipients</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-subtitle>{{$t('domains.emailCount')}}</v-list-item-subtitle>
                            <v-list-item-title>{{ formatNumber(item.totalEmailRecipients) }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
        </v-list>
        </v-col>
        </v-row>
        <v-card-actions>
            <v-btn text :to="{ name: 'contacts-c-import'}"><v-icon left>$importCustomers</v-icon>{{$t('overview.tasks.customers')}}</v-btn>
            <v-btn text :to="{ name: 'contacts-o-import'}"><v-icon left>$importOrders</v-icon>{{$t('overview.tasks.orders')}}</v-btn>
            <v-btn text :to="{ name: 'add-form'}"><v-icon left>$form</v-icon>{{$t('contacts.tags.addForm')}}</v-btn>
            <quick-unsubscribe :domain="item.id" />
            <v-btn text :to="{ name: 'contacts-unsubscribe'}"><v-icon left>$unsubscribeBatch</v-icon>{{$t('contacts.unsubscribe.title')}}</v-btn>
        </v-card-actions>
    </v-card>

    <transition name="slide-x-transition" mode="out-in">
    <router-view />
    </transition>
    <!--
    <router-view v-slot="{ Component, route }">
        <transition name="fade">
            <component :is="Component" :key="route.path" />
        </transition>
    </router-view>
    -->
   </template>
   <v-skeleton-loader v-else type="card" />
   </v-container>
   
</template>

<script>
import Formatters from "@/mixins/formatters"
import QuickUnsubscribe from "@/components/QuickUnsubscribe"
import { mapState } from 'vuex'
export default {
    name: 'Contacts',
    mixins: [Formatters],
    components: {QuickUnsubscribe},
    computed: {
        importsRoute: {
            get() {
                return this.$route.name != 'domain-overview';
            },
            set(v) {
                if(!v) {
                    this.$router.push({name: 'domain-overview'});
                }
            }
        },
        ...mapState('domains', ['item'])
    }
}
</script>

